import { createBrowserRouter } from 'react-router';

import { AppLayout } from './components/layout/AppLayout.js';
import { ProtectedRoute } from './components/layout/ProtectedRoute.js';
import { ChecklistBuilderPage } from './pages/ChecklistBuilderPage.js';
import { ChecklistsPage } from './pages/ChecklistsPage.js';
import { ChecklistTemplateBuilderPage } from './pages/ChecklistTemplateBuilderPage.js';
import { ChecklistTemplatesPage } from './pages/ChecklistTemplatesPage.js';
import { ClientDetailPage } from './pages/ClientDetailPage.js';
import { ClientsPage } from './pages/ClientsPage.js';
import { ContactsPage } from './pages/ContactsPage.js';
import { DashboardPage } from './pages/dashboard/DashboardPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { PropertiesPage } from './pages/PropertiesPage.js';
import { PropertyDetailPage } from './pages/PropertyDetailPage.js';
import { ServiceOrderDetailPage } from './pages/ServiceOrderDetailPage.js';
import { ServiceOrdersPage } from './pages/ServiceOrdersPage.js';
import { ServiceRequestsPage } from './pages/ServiceRequestsPage.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { TimeTrackingPage } from './pages/TimeTrackingPage.js';
import { UnitDetailPage } from './pages/UnitDetailPage.js';
import { UnitsPage } from './pages/UnitsPage.js';
import { UserDetailPage } from './pages/UserDetailPage.js';
import { UsersPage } from './pages/UsersPage.js';

export const router = createBrowserRouter([
  {
    path: 'login',
    element: <LoginPage />,
  },
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'service-orders', element: <ServiceOrdersPage /> },
      { path: 'service-orders/new', element: <ServiceOrderDetailPage /> },
      { path: 'service-orders/:id', element: <ServiceOrderDetailPage /> },
      { path: 'clients', element: <ClientsPage /> },
      { path: 'clients/new', element: <ClientDetailPage /> },
      { path: 'clients/:id', element: <ClientDetailPage /> },
      { path: 'properties', element: <PropertiesPage /> },
      { path: 'properties/new', element: <PropertyDetailPage /> },
      { path: 'properties/:id', element: <PropertyDetailPage /> },
      { path: 'checklists', element: <ChecklistsPage /> },
      { path: 'checklists/new', element: <ChecklistBuilderPage /> },
      { path: 'checklists/:id/edit', element: <ChecklistBuilderPage /> },
      { path: 'checklist-templates', element: <ChecklistTemplatesPage /> },
      { path: 'checklist-templates/new', element: <ChecklistTemplateBuilderPage /> },
      { path: 'checklist-templates/:id/edit', element: <ChecklistTemplateBuilderPage /> },
      { path: 'time-tracking', element: <TimeTrackingPage /> },
      { path: 'units', element: <UnitsPage /> },
      { path: 'units/:id', element: <UnitDetailPage /> },
      { path: 'contacts', element: <ContactsPage /> },
      { path: 'service-requests', element: <ServiceRequestsPage /> },
      { path: 'users', element: <UsersPage /> },
      { path: 'users/new', element: <UserDetailPage /> },
      { path: 'users/:id', element: <UserDetailPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
]);
